'use client';

import { cn } from '@/utils/cn';
import Image from 'next/image';
import type React from 'react';

interface ArtistAvatarProps {
    slug?: string | null;
    avatar?: {
        url?: string | null;
        width?: number | null;
        height?: number | null;
    } | null;
    className?: string;
}

export default function ArtistAvatar({ slug, avatar, className = '' }: ArtistAvatarProps) {
    if (!avatar?.url || !slug) {
        return null;
    }

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        // Dispatch event to open artist panel
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('openArtistPanel', { detail: { slug } }));
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className={cn('artist-avatar relative pr-1', className ?? '')}
        >
            <div className="relative aspect-h-3 aspect-w-2">
                <Image
                    src={avatar.url}
                    alt=""
                    fill
                    sizes="(max-width: 768px) 33vw, 16vw"
                    className="object-cover"
                    style={{ mixBlendMode: 'luminosity' }}
                />
            </div>
        </button>
    );
}
